import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseService } from './loja/base.service';

@Injectable()
export class UnitService extends BaseService {

  constructor(protected http: Http) {
    super(http, 'api/v2/admin', 'regional/select/unidade')
  }

}


// WEBPACK FOOTER //
// ./src/app/services/unit.service.ts